/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type ProviderSuggestionContext = typeof ProviderSuggestionContext[keyof typeof ProviderSuggestionContext];


export const ProviderSuggestionContext = {
  PCP: 'PCP',
  PreviousVisit: 'PreviousVisit',
  FromAppointment: 'FromAppointment',
  PreviousClaim: 'PreviousClaim',
} as const;
